import { dehydrate, QueryClient } from '@tanstack/react-query';
import { getGetPricingQueryOptions } from '@/api';
import { Pricing } from '@/module/payment';
import { CountryCodeFromServerProvider } from '@/shared/contexts';
import { UserCookieManager } from '@/shared/cookies';
import { getDefaultServerSideProps } from '@/utils';
import { withServerSideUserCountryCode } from '@/utils/next/withServerSideUserCountryCode';
export default function PricingPage(props: {
  userCountryCode: string;
}) {
  return <CountryCodeFromServerProvider countryCode={props.userCountryCode} data-sentry-element="CountryCodeFromServerProvider" data-sentry-component="PricingPage" data-sentry-source-file="index.page.tsx">
      <Pricing data-sentry-element="Pricing" data-sentry-source-file="index.page.tsx" />
    </CountryCodeFromServerProvider>;
}
export const getServerSideProps = withServerSideUserCountryCode(async ctx => {
  const queryClient = new QueryClient();
  const userCountryCode = UserCookieManager.getPreferredCountryCode(ctx.req);
  try {
    await queryClient.prefetchQuery(getGetPricingQueryOptions({
      countryCode: userCountryCode ?? 'US'
    }));
  } catch (e) {
    console.error(e);
  }
  return {
    props: {
      ...(await getDefaultServerSideProps(ctx)).props,
      dehydratedState: dehydrate(queryClient)
    }
  };
});